import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../../auth/services/authentication.service';
import { UiStateStore } from '../../../shared/store/ui-state-store.service';
import { AccountActivationStatus } from '../../../shared/enums/account-activation-status';

@Component({
  selector: 'app-activate-account',
  templateUrl: './activate-account.component.html',
  styleUrls: ['./activate-account.component.scss']
})
export class ActivateAccountComponent implements OnInit {

  activationStatus: AccountActivationStatus = AccountActivationStatus.Activating;
  activationStatuses = AccountActivationStatus;
  error: string = "";

  constructor(
    public route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public uiStore: UiStateStore,
    public router: Router) {

    if (this.route.snapshot.queryParamMap.has("oobCode")) {
      setTimeout(() => {
        let oobCode = this.route.snapshot.queryParamMap.get("oobCode");
        if (oobCode) {
          this.authenticationService.fireActivateAccount(oobCode).then(resp => {
            this.activationStatus = AccountActivationStatus.Activated;
          }).catch(err => {
            this.error = err.message;
            this.activationStatus = AccountActivationStatus.Failure;
          });
        }
      }, 2000);
    }
  }

  ngOnInit() {
  }

}
